import { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

const fmt = (n) => new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n);

export function AnimatedRupiah({ value, className = "", testId = "hasil-refund" }) {
    const spring = useSpring(value || 0, { stiffness: 80, damping: 20 });
    useEffect(() => {
        spring.set(value || 0);
    }, [value, spring]);
    const text = useTransform(spring, (v) => "Rp " + fmt(Math.max(0, Math.round(v))));
    return (
        <motion.span className={className} data-testid={testId}>
            {text}
        </motion.span>
    );
}

export function AnimatedNumber({ value, suffix = "", className = "", testId = "hasil-angka" }) {
    const spring = useSpring(value || 0, { stiffness: 80, damping: 20 });
    useEffect(() => {
        spring.set(value || 0);
    }, [value, spring]);
    const text = useTransform(spring, (v) => fmt(Math.max(0, Math.round(v))) + suffix);
    return (
        <motion.span className={className} data-testid={testId}>
            {text}
        </motion.span>
    );
}
